import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { parseNewDateToDDMMYYYnoTime } from "../../../../Utils/dateHelper";
import { controlTypes, externalApiTypes } from "../../../../Config/constants";

import Divider from "@mui/material/Divider";
import { dataService } from "../../../../Services/data/data.service";

export default function TableHighLow(props) {
  const [mostCommonDate, setMostCommonDate] = useState("/");
  const [leastCommonDate, setLeastCommonDate] = useState("/");
  const [averagePrice, setAveragePrice] = useState({ average: "/", price: "/" });
  const [currency, setCurrency] = useState({ symbol: "" });

  useEffect(() => {
    if (props.currency) {
      setCurrency(props.currency);
    }
  }, [props.currency]);

  useEffect(() => {
    if (props.detail.measurements !== null && props.detail.measurements !== undefined) {
      findMostCommonDate(props.detail.measurements);
      findLeastCommonDate(props.detail.measurements);
      getAllActiveDates(props.detail.measurements);
    }
  }, [props.detail.measurements]); // eslint-disable-line react-hooks/exhaustive-deps

  const classes = useStyles();
  const navigate = useNavigate();

  function padTo2Digits(num) {
    return num.toString().padStart(2, "0");
  }

  function convertMsToTime(milliseconds) {
    let seconds = Math.floor(milliseconds / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);

    seconds = seconds % 60;
    minutes = minutes % 60;
    hours = hours % 24;

    return `${padTo2Digits(hours)}:${padTo2Digits(minutes)}:${padTo2Digits(seconds)}`;
  }

  const findMostCommonDate = (measurements) => {
    //Check which date got the most measurements
    if (measurements[0].typeId === controlTypes.STOPWATCH || (measurements[0].typeId === controlTypes.EXTERNALAPI && measurements[0].externalApiTypeId === externalApiTypes.STOPWATCH)) {
      //In case of a stopwatch, check which date had the longest-time measurments.
      const measurementsGroupedByDate = measurements.reduce((acc, item) => {
        const { date } = item;
        if (!acc[date]) {
          acc[date] = [];
        }
        acc[date].push(item);
        return acc;
      }, {});
      var most = 0;

      var mostDate = "";
      for (const [date, items] of Object.entries(measurementsGroupedByDate)) {
        var total = items.reduce((a, v) => (a = a + v.integerValue), 0);
        if (total > most) {
          most = total;
          mostDate = date.split("T")[0];
        }
      }

      mostDate = parseNewDateToDDMMYYYnoTime(new Date(Date.parse(mostDate)));
      setMostCommonDate(mostDate);
    } else if (measurements[0].typeId === controlTypes.EXTERNALAPI && measurements[0].externalApiTypeId === externalApiTypes.NUMERIC) {
      // for each day, add integerValue together (if isNegative, subtract)
      const measurementsGroupedByDate = measurements.reduce((acc, item) => {
        const { date } = item;
        if (!acc[date]) {
          acc[date] = [];
        }
        acc[date].push(item);
        return acc;
      }, {});
      var most = 0;
      var mostDate = "";
      for (const [date, items] of Object.entries(measurementsGroupedByDate)) {
        var total = items.reduce((a, v) => (a = a + (v.isNegative ? -1 : 1) * v.numericValue), 0);
        if (total > most) {
          most = total;
          mostDate = date.split("T")[0];
        }
      }
      mostDate = parseNewDateToDDMMYYYnoTime(new Date(Date.parse(mostDate)));
      setMostCommonDate(mostDate);
    } else if (measurements[0].typeId === controlTypes.COUNTER) {
      // group by date and then check where measurements with isNegative = false - measurements with isNegative = true is the highest
      const measurementsGroupedByDate = measurements.reduce((acc, item) => {
        const { date } = item;
        if (!acc[date]) {
          acc[date] = [];
        }
        acc[date].push(item);
        return acc;
      }, {});
      var most = 0;
      var mostDate = "";
      for (const [date, items] of Object.entries(measurementsGroupedByDate)) {
        var total = items.reduce((a, v) => (a = a + (v.isNegative ? -1 : 1) * v.integerValue), 0);
        if (total > most) {
          most = total;
          mostDate = date.split("T")[0];
        }
      }
      mostDate = parseNewDateToDDMMYYYnoTime(new Date(Date.parse(mostDate)));
      setMostCommonDate(mostDate);
    } else {
      //For the others, just take a sum
      let tempMostDates = measurements.map((measurement) => parseNewDateToDDMMYYYnoTime(new Date(Date.parse(measurement.insertedOn))));
      let dateMap = new Map();
      tempMostDates.forEach((date) => {
        if (dateMap.has(date)) {
          dateMap.set(date, dateMap.get(date) + 1);
        } else {
          dateMap.set(date, 1);
        }
      });
      let mostCommonDate = "";
      let mostCommonCount = 0;
      dateMap.forEach((count, date) => {
        if (count > mostCommonCount) {
          mostCommonDate = date;
          mostCommonCount = count;
        }
      });
      setMostCommonDate(mostCommonDate);
    }
  };

  const findLeastCommonDate = (measurements) => {
    //Check lowest measurement date
    var measurementToUse = measurements[0];
    measurements.map((measurement) => {
      if (measurement.measurementId !== 0) {
        measurementToUse = measurement;
      }
    });

    if (measurementToUse !== null) {
      //If it is a stopwatch check the date where the LEAST time was measured
      if (measurementToUse.typeId === controlTypes.STOPWATCH || (measurementToUse.typeId === controlTypes.EXTERNALAPI && measurementToUse.externalApiTypeId === externalApiTypes.STOPWATCH)) {
        const measurementsGroupedByDate = measurements.reduce((acc, item) => {
          const { date } = item;
          if (!acc[date]) {
            acc[date] = [];
          }
          acc[date].push(item);
          return acc;
        }, {});

        var least = 0;
        var leastDate = "";
        var count = 0;
        for (const [date, items] of Object.entries(measurementsGroupedByDate)) {
          var total = items.reduce((a, v) => (a = a + v.integerValue), 0);

          if (total < least || count === 0) {
            least = total;
            leastDate = date.split("T")[0];
          }
          count = count + 1;
        }

        leastDate = parseNewDateToDDMMYYYnoTime(new Date(Date.parse(leastDate)));
        setLeastCommonDate(leastDate);
      } else if (measurementToUse.typeId === controlTypes.EXTERNALAPI && measurementToUse.externalApiTypeId === externalApiTypes.NUMERIC) {
        // for each day, add integerValue together (if isNegative, subtract)
        const measurementsGroupedByDate = measurements.reduce((acc, item) => {
          const { date } = item;
          if (!acc[date]) {
            acc[date] = [];
          }
          acc[date].push(item);
          return acc;
        }, {});
        var least = 0;
        var leastDate = "";
        var count = 0;
        for (const [date, items] of Object.entries(measurementsGroupedByDate)) {
          var total = items.reduce((a, v) => (a = a + (v.isNegative ? -1 : 1) * v.numericValue), 0);
          if (total < least || count === 0) {
            least = total;
            leastDate = date.split("T")[0];
          }
          count = count + 1;
        }
        leastDate = parseNewDateToDDMMYYYnoTime(new Date(Date.parse(leastDate)));
        setLeastCommonDate(leastDate);
      } else if (measurementToUse.typeId === controlTypes.COUNTER) {
        // group by date and then check where measurements with isNegative = false - measurements with isNegative = true is the lowest
        const measurementsGroupedByDate = measurements.reduce((acc, item) => {
          const { date } = item;
          if (!acc[date]) {
            acc[date] = [];
          }
          acc[date].push(item);
          return acc;
        }, {});
        var least = 0;
        var leastDate = "";
        var count = 0;
        for (const [date, items] of Object.entries(measurementsGroupedByDate)) {
          var total = items.reduce((a, v) => (a = a + (v.isNegative ? -1 : 1) * v.integerValue), 0);
          if (total < least || count === 0) {
            least = total;
            leastDate = date.split("T")[0];
          }
          count = count + 1;
        }
        leastDate = parseNewDateToDDMMYYYnoTime(new Date(Date.parse(leastDate)));
        setLeastCommonDate(leastDate);
      } else {
        //least total of measurment
        let tempLeastDate = measurements.map((measurement) => parseNewDateToDDMMYYYnoTime(new Date(Date.parse(measurement.insertedOn))));
        let dateMap = new Map();
        tempLeastDate.forEach((date) => {
          if (dateMap.has(date)) {
            dateMap.set(date, dateMap.get(date) + 1);
          } else {
            dateMap.set(date, 1);
          }
        });
        let leastCommonDate = "";
        let leastCommonCount = 999999999;
        dateMap.forEach((count, date) => {
          if (count < leastCommonCount) {
            leastCommonDate = date;
            leastCommonCount = count;
          }
        });
        setLeastCommonDate(leastCommonDate);
      }
    }
  };

  const getAllActiveDates = (measurements) => {
    if (measurements.length > 0) {
      let tempDates = measurements.map((measurement) => parseNewDateToDDMMYYYnoTime(new Date(Date.parse(measurement.insertedOn))));
      let arrUniqueValues = getUniqueValuesFromArray(tempDates);
      let arrEventsPerDay = [];
      arrUniqueValues.forEach((strMeasurementDate) => {
        var dateParts = strMeasurementDate.split("/");
        var tempFromDate = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
        var tempToDate = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]).addHours(24);
        let objFilteredMeasurements = measurements.filter((x) => new Date(x.insertedOn) >= tempFromDate && new Date(x.insertedOn) <= tempToDate);
        let total;
        if (objFilteredMeasurements[0].typeId === controlTypes.STOPWATCH || (measurements[0].typeId === controlTypes.EXTERNALAPI && measurements[0].externalApiTypeId === externalApiTypes.STOPWATCH)) {
          //Som van de tijden
          total = objFilteredMeasurements.reduce((a, v) => (a = a + v.integerValue), 0);
        } else if (measurements[0].typeId === controlTypes.EXTERNALAPI && measurements[0].externalApiTypeId === externalApiTypes.NUMERIC) {
          total = objFilteredMeasurements.reduce((a, v) => (a = a + (v.isNegative ? -1 : 1) * v.numericValue), 0);
        } else if (objFilteredMeasurements[0].typeId === controlTypes.COUNTER) {
          //Som van de events
          total = objFilteredMeasurements.reduce((a, v) => (a = a + (v.isNegative ? -1 : 1)), 0);
        } else {
          //Som van het aantal events
          total = objFilteredMeasurements.length;
        }
        arrEventsPerDay.push({ date: tempFromDate, total: total });
      });

      let intSumOfTotal = arrEventsPerDay.reduce((a, b) => a + b.total, 0);
      let floatAvgOfTotal = intSumOfTotal / arrEventsPerDay.length || 0;

      let numberPrice = 0;
      if (measurements[0].typeId === controlTypes.STOPWATCH || (measurements[0].typeId === controlTypes.EXTERNALAPI && measurements[0].externalApiTypeId === externalApiTypes.STOPWATCH)) {
        let avgHour = floatAvgOfTotal / 3600;
        numberPrice = avgHour * props.detail.price;
        floatAvgOfTotal = new Date(floatAvgOfTotal * 1000).toISOString().substring(11, 19);
      } else if (measurements[0].typeId === controlTypes.EXTERNALAPI && measurements[0].externalApiTypeId === externalApiTypes.NUMERIC) {
        let avgCount = floatAvgOfTotal;
        numberPrice = avgCount * props.detail.price;
        floatAvgOfTotal = floatAvgOfTotal.toLocaleString("nl-BE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      } else if (measurements[0].typeId === controlTypes.COUNTER) {
        numberPrice = floatAvgOfTotal * props.detail.price;
        floatAvgOfTotal = floatAvgOfTotal.toLocaleString("nl-BE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      } else {
        numberPrice = floatAvgOfTotal * props.detail.price;
      }
      setAveragePrice({ average: floatAvgOfTotal, price: numberPrice.toLocaleString("nl-BE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) });
    } else {
      setAveragePrice({ average: "/", price: "/" });
    }
  };
  // eslint-disable-next-line
  Date.prototype.addHours = function (h) {
    this.setHours(this.getHours() + h);
    return this;
  };

  const getUniqueValuesFromArray = (array) => {
    var newArray = [];
    newArray = array.filter(function (elem, pos) {
      return array.indexOf(elem) === pos;
    });
    return newArray;
  };

  const findEventsWithDate = (measurements, date) => {
    if (date !== "/" && date !== undefined) {
      let events = measurements.filter((measurement) => parseNewDateToDDMMYYYnoTime(new Date(Date.parse(measurement.insertedOn))) === date);
      if (events.length > 0) {
        if (events[0].typeId === controlTypes.STOPWATCH || (events[0].typeId === controlTypes.EXTERNALAPI && events[0].externalApiTypeId === externalApiTypes.STOPWATCH)) {
          //Stopwatch type
          let sum = 0;
          let filterEvents = events.filter((x) => x.stopValue !== null);

          filterEvents.forEach((event) => {
            let start = new Date(Date.parse(event.startValue));
            let stop = new Date(Date.parse(event.stopValue));
            let diff = stop.getTime() - start.getTime();
            sum += diff;
          });
          return convertMsToTime(sum);
        } else if (events[0].typeId === controlTypes.EXTERNALAPI && events[0].externalApiTypeId === externalApiTypes.NUMERIC) {
          //Count type
          let sum = 0;
          events.forEach((event) => {
            if (event.isNegative) {
              sum -= event.numericValue;
            } else {
              sum += event.numericValue;
            }
          });
          return sum;
        } else if (events[0].typeId === controlTypes.COUNTER) {
          //Counter type
          let sum = 0;
          events.forEach((event) => {
            if (event.isNegative) {
              sum--;
            } else {
              sum++;
            }
          });
          return sum;
        } else {
          return events.length;
        }
      }
    }
  };

  const findPrice = (value, detail) => {
    if (value !== "/" && value !== undefined) {
      if (detail.controlTypeId === controlTypes.STOPWATCH || (detail.controlTypeId === controlTypes.EXTERNALAPI && detail.externalApiTypeId === externalApiTypes.STOPWATCH)) {
        const [hours, minutes, seconds] = value.split(":");
        // minutes are worth 60 seconds. Hours are worth 60 minutes.
        let totalSeconds = convertToSeconds(hours, minutes, seconds);
        let tempTotal = (detail.price / 3600) * totalSeconds;
        return tempTotal.toLocaleString("nl-BE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      } else {
        let tempTotal = value * detail.price;

        return tempTotal.toLocaleString("nl-BE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
    }

    // const events = measurements.filter(measurement => parseNewDateToDDMMYYYnoTime(new Date(Date.parse(measurement.insertedOn))) === date);
    // if (events[0].startValue !== null && events[0].stopValue !== null) {
    //     let sum = 0;
    //     events.forEach(event => {
    //         const start = new Date(Date.parse(event.startValue));
    //         const stop = new Date(Date.parse(event.stopValue));
    //         const diff = stop.getTime() - start.getTime();
    //         sum += diff;
    //     });
    //     return (convertMsToTime(sum));
    // }
    // else {
    //     return (events.length);
    // }
  };

  function convertToSeconds(hours, minutes, seconds) {
    return Number(hours) * 60 * 60 + Number(minutes) * 60 + Number(seconds);
  }

  const handleResultsRedirect = () => {
    navigate(`/results/${props.projectQr}`);
  };

  return (
    <div className={classes.eventBoxStyle}>
      {props.detail.measurements.length > 0 && (
        <div className={classes.buttonContainer} onClick={() => handleResultsRedirect(mostCommonDate)}>
          <div className={classes.infoBlock}>
            <small style={{ fontWeight: 600 }}>Date: </small>
            {mostCommonDate}
          </div>
          <div className={classes.infoBlock}>
            <small style={{ fontWeight: 600 }}>
              {props.detail.controlTypeId === controlTypes.STOPWATCH || (props.detail.controlTypeId === controlTypes.EXTERNALAPI && props.detail.externalApiTypeId === externalApiTypes.STOPWATCH)
                ? "Time: "
                : props.detail.controlTypeId === controlTypes.COUNTER || (props.detail.controlTypeId === controlTypes.EXTERNALAPI && props.detail.externalApiTypeId == externalApiTypes.NUMERIC)
                ? "Count: "
                : "Events: "}
            </small>
            {findEventsWithDate(props.detail.measurements, mostCommonDate)}
          </div>
          <div className={classes.infoBlock}>
            <small style={{ fontWeight: 600 }}>Effect in {currency.symbol}: </small>
            {currency.symbol}
            {findPrice(findEventsWithDate(props.detail.measurements, mostCommonDate), props.detail)}
          </div>
          <div style={{ paddingRight: "8px", width: "25%", float: "right" }}>
            <div className={classes.dataBlock} style={{ background: props.detail.isProfit ? "#28a745" : "#dc3545" }}>
              High
            </div>
          </div>
        </div>
      )}

      <Divider></Divider>
      {props.detail.measurements.length > 0 && (
        <div className={classes.averageContainer}>
          <div className={classes.infoBlock}></div>
          <div className={classes.infoBlock}>
            <small style={{ fontWeight: 600 }}>
              {props.detail.controlTypeId === controlTypes.STOPWATCH || (props.detail.controlTypeId === controlTypes.EXTERNALAPI && props.detail.externalApiTypeId === externalApiTypes.STOPWATCH)
                ? "Average time: "
                : props.detail.controlTypeId === controlTypes.COUNTER || (props.detail.controlTypeId === controlTypes.EXTERNALAPI && props.detail.externalApiTypeId == externalApiTypes.NUMERIC)
                ? "Average count: "
                : "Average events: "}
            </small>
            {averagePrice.average.toLocaleString("nl-BE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </div>
          <div className={classes.infoBlock}>
            <small style={{ fontWeight: 600 }}>Effect in {currency.symbol}: </small>
            {currency.symbol}
            {averagePrice.price}
          </div>
          <div style={{ paddingRight: "8px", width: "25%", float: "right" }}>
            <div className={classes.dataBlock} style={{ background: "grey" }}>
              Average
            </div>
          </div>
        </div>
      )}
      <Divider></Divider>
      {props.detail.measurements.length > 0 && (
        <div className={classes.buttonContainer} onClick={() => handleResultsRedirect(leastCommonDate)}>
          <div className={classes.infoBlock}>
            <small style={{ fontWeight: 600 }}>Date: </small>
            {leastCommonDate}
          </div>
          <div className={classes.infoBlock}>
            <small style={{ fontWeight: 600 }}>
              {props.detail.controlTypeId === controlTypes.STOPWATCH || (props.detail.controlTypeId === controlTypes.EXTERNALAPI && props.detail.externalApiTypeId === externalApiTypes.STOPWATCH)
                ? "Time: "
                : props.detail.controlTypeId === controlTypes.COUNTER || (props.detail.controlTypeId === controlTypes.EXTERNALAPI && props.detail.externalApiTypeId == externalApiTypes.NUMERIC)
                ? "Count: "
                : "Events: "}
            </small>
            {findEventsWithDate(props.detail.measurements, leastCommonDate)}
          </div>
          <div className={classes.infoBlock}>
            <small style={{ fontWeight: 600 }}>Effect in {currency.symbol}: </small>
            {currency.symbol}
            {findPrice(findEventsWithDate(props.detail.measurements, leastCommonDate), props.detail)}
          </div>
          <div style={{ paddingRight: "8px", width: "25%", float: "right" }}>
            <div className={classes.dataBlock} style={{ background: props.detail.isProfit ? "#dc3545" : "#28a745" }}>
              Low
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  infoBlock: {
    display: "flex",
    flexDirection: "column",
    width: "25%",
    paddingLeft: "8px",
  },

  dataBlock: {
    float: "right",
    width: "70px",
    color: "white",
    paddingTop: "8px",
    paddingBottom: "8px",
    borderRadius: "5px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "bold",
  },

  buttonContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
    width: "100%",
    paddingTop: "20px",
    paddingBottom: "20px",
    "&:hover": {
      background: "#e8e6e6",
      cursor: "pointer",
    },
  },
  averageContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
    width: "100%",
    paddingTop: "8px",
    paddingBottom: "8px",
  },

  eventBoxStyle: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    height: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "100%",
    },
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      width: "100%",
    },
  },
}));
